import styled from 'styled-components'
import { blue, red } from '@/theme/colors'
import { text } from '@/theme/typography'

/** Heading that separates the payups list from the expenses list above it. */
export const SectionHeading = styled.h2`
	margin: 40px 0 16px;
	${text.title}
	color: ${blue};
`

/**
 * A non-clickable table row for the payups list (payups have no detail page).
 * Soft-deleted payups get a faint red tint, matching the clickable list rows.
 */
export const StaticRow = styled.tr<{ $deleted?: boolean }>`
	background-color: ${({ $deleted }) => ($deleted ? `${red}10` : 'transparent')};

	&:last-child td {
		border-bottom: none;
	}
`

